import { useMutation } from '@tanstack/react-query';

import { CancellationFee } from '@/models';
import { getSMPBackendAPIAdmin } from '@/proxy/apiController';
import { UpdateCancellationFeeDto } from '@/proxy/dtos/updateCancellationFeeDto';
import { eurosToCents } from '@/utils/numberHelper';

const toRequest = (fee: CancellationFee): UpdateCancellationFeeDto & { feeId: string } => ({
  feeId: fee.id,
  name: fee.name,
  description: fee.description,
  value: eurosToCents(fee.value),
});

function updateCancellationFee(resourceId: string, fee: CancellationFee) {
  const data = toRequest(fee);
  return getSMPBackendAPIAdmin().resourceBookingsControllerUpdateCancellationFeeV1(
    resourceId,
    data.feeId,
    data
  );
}

export function useUpdateCancellationFee() {
  return useMutation({
    mutationFn: ({ resourceId, fee }: { resourceId: string; fee: CancellationFee }) =>
      updateCancellationFee(resourceId, fee),
  });
}
